// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tableSettings__tableSettingsContainer___1myF9 {\n    font-size: 12px;\n    //background-color: red;\n  }\n  \n  \n  \n  .tableSettings__innerSettingsContainer___V5_nE {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n  \n  \n  \n  .tableSettings__tableSettingsTooltip___2xyFW {\n    margin-left: 0px;\n    font-size: 12px;\n  }\n  \n  \n  \n  .tableSettings__dropdownCheckbox___1peUK {\n  margin-bottom: 0;\n} ", ""]);
// Exports
exports.locals = {
	"tableSettingsContainer": "tableSettings__tableSettingsContainer___1myF9",
	"innerSettingsContainer": "tableSettings__innerSettingsContainer___V5_nE",
	"tableSettingsTooltip": "tableSettings__tableSettingsTooltip___2xyFW",
	"dropdownCheckbox": "tableSettings__dropdownCheckbox___1peUK"
};
module.exports = exports;
